(function() {
  define('tlhServicesNotifier',['angular'], function() {
    'use strict';
    return angular.module('tlhServicesNotifier', []).factory('TlhNotifierService', [
      '$rootScope', function($rootScope) {
        var factory;
        factory = {};
        factory.send = function(message, data) {
          return $rootScope.$broadcast(message, data);
        };
        return factory;
      }
    ]);
  });

}).call(this);

//# sourceMappingURL=notifier.js.map
;
